module.exports = __webpack_public_path__ + "img/69581800_2265226090272621_2706279156981504810_n.d47d65f8.jpg";